import React from 'react';
import PropTypes from 'prop-types';
import { Router, Route, hashHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'

const router = (props) => {
  const history = syncHistoryWithStore(hashHistory, props.store);
  return (<Router history={history}>
    <Route path="/:id/edit" component={props.edit} />
    <Route path="/add" component={props.add} />
    <Route path="/:id" component={props.show} />
    <Route path="/" component={props.list} />
  </Router>);
};

router.propTypes = {
  store: PropTypes.any,
  edit: PropTypes.element,
  add: PropTypes.element,
  list: PropTypes.element,
  show: PropTypes.element
};

export default router;